/* Peakspan H2 — REMAKE interaction layer (2026-08-27). Vanilla, dependency-free, defer-safe.
   Components: 360° spinner [data-ps-360] · hover-to-play tiles [data-ps-hover-video] · chapter films [data-ps-film]
   · snap carousel [data-ps-carousel] · reveal/stagger (re-armed for new nodes). Respects prefers-reduced-motion. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOUCH = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var io = 'IntersectionObserver' in window;

  /* ---------------------------------------------------------------- 360° spinner */
  function pad(i) { return (i < 10 ? '0' : '') + i; }
  function Spinner(el) {
    if (el.__ps360) return; el.__ps360 = this;
    this.el = el; this.n = parseInt(el.getAttribute('data-frames') || '48', 10);
    this.src = el.getAttribute('data-src') || ''; this.mode = el.getAttribute('data-mode') || 'drag';
    this.srcs = null; try { this.srcs = JSON.parse(el.getAttribute('data-srcs') || 'null'); } catch (_) { this.srcs = null; }
    if (this.srcs && this.srcs.length) { this.n = this.srcs.length; this.src = this.srcs[0]; }
    this.canvas = el.querySelector('.ps-360__canvas'); this.ctx = this.canvas && this.canvas.getContext('2d');
    this.progress = el.querySelector('[data-ps-360-progress] i');
    this.frames = new Array(this.n); this.loaded = 0; this.frame = 0; this.vel = 0; this.dragging = false;
    this.lastX = 0; this.idleT = 0; this.visible = false; this.raf = null; this.ready = false;
    if (!this.canvas || !this.ctx || !this.src) return;
    var self = this;
    this.resize(); window.addEventListener('resize', function () { self.resize(); self.draw(); }, { passive: true });
    this.load();
    this.bind();
    if (io) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { self.visible = e.isIntersecting; if (self.visible) self.tick(); }); }, { threshold: 0.15 }).observe(el);
    } else { this.visible = true; this.tick(); }
  }
  Spinner.prototype.resize = function () {
    var r = this.el.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    this.w = Math.max(1, Math.round(r.width)); this.h = Math.max(1, Math.round(r.height));
    this.canvas.width = this.w * d; this.canvas.height = this.h * d; this.ctx.setTransform(d, 0, 0, d, 0, 0);
  };
  Spinner.prototype.load = function () {
    var self = this, order = [0];
    for (var s = 24; s >= 1; s = s >> 1) for (var i = 0; i < this.n; i += s) if (order.indexOf(i) < 0) order.push(i);
    for (var i = 0; i < this.n; i++) if (order.indexOf(i) < 0) order.push(i);
    var idx = 0, inflight = 0;
    function next() {
      while (inflight < 4 && idx < order.length) {
        (function (k) {
          var im = new Image(); im.decoding = 'async'; inflight++;
          im.onload = im.onerror = function () { inflight--; self.frames[k] = im.naturalWidth ? im : null; self.loaded++;
            if (self.progress) self.progress.style.width = Math.round(100 * self.loaded / self.n) + '%';
            if (k === 0 && !self.ready) { self.ready = true; self.el.classList.add('is-ready'); self.draw(); }
            if (self.loaded === self.n) self.el.classList.add('is-loaded');
            next(); };
          im.src = self.srcs ? self.srcs[k] : self.src.replace('{i}', pad(k + 1));
        })(order[idx++]);
      }
    }
    next();
  };
  Spinner.prototype.draw = function () {
    var f = ((Math.round(this.frame) % this.n) + this.n) % this.n, im = this.frames[f];
    if (!im) { for (var k = 1; k < this.n && !im; k++) im = this.frames[(f - k + this.n) % this.n]; }
    if (!im) return;
    var ctx = this.ctx, w = this.w, h = this.h, s = Math.max(w / im.naturalWidth, h / im.naturalHeight);
    var dw = im.naturalWidth * s, dh = im.naturalHeight * s;
    ctx.clearRect(0, 0, w, h); ctx.drawImage(im, (w - dw) / 2, (h - dh) / 2, dw, dh);
  };
  Spinner.prototype.bind = function () {
    var self = this, el = this.el;
    function down(e) { self.dragging = true; self.vel = 0; self.lastX = e.clientX; el.classList.add('is-touched'); if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (_) {} } }
    function move(e) { if (!self.dragging) return; var dx = e.clientX - self.lastX; self.lastX = e.clientX; var df = dx / 600 * self.n; self.frame += df; self.vel = df; self.idleT = 0; self.draw(); }
    function up() { self.dragging = false; self.idleT = 0; }
    el.addEventListener('pointerdown', down); el.addEventListener('pointermove', move, { passive: true });
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up); el.addEventListener('pointerleave', up);
    el.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { self.frame -= 1; self.draw(); } if (e.key === 'ArrowRight') { self.frame += 1; self.draw(); } });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (this.mode === 'scroll') window.addEventListener('scroll', function () { if (!self.visible || self.dragging) return; var r = el.getBoundingClientRect(), vh = window.innerHeight; var p = 1 - (r.top + r.height) / (vh + r.height); self.frame = p * self.n; self.draw(); }, { passive: true });
  };
  /* Film layer: idle rotation plays the real 24 fps film; the frame canvas takes over only while dragging. */
  Spinner.prototype.film = function () {
    var v = this.el.querySelector('.ps-360__film'); if (!v) return null;
    if (!v.getAttribute('src')) {
      var mobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      var src = mobile ? (v.getAttribute('data-mobile-src') || v.getAttribute('data-desktop-src')) : (v.getAttribute('data-desktop-src') || v.getAttribute('data-mobile-src'));
      if (src) { v.setAttribute('src', src); v.load(); }
      var self = this; v.addEventListener('playing', function () { self.el.classList.add('is-filmready'); });
    }
    return v;
  };
  Spinner.prototype.filmPlay = function () { var v = this.film(); if (!v || RM) return; var d = v.duration || 10.04; try { v.currentTime = ((this.frame % this.n) + this.n) % this.n / this.n * d; } catch (_) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); this.el.classList.remove('is-frames'); };
  Spinner.prototype.filmPause = function () { var v = this.film(); if (!v) return; v.pause(); var d = v.duration || 10.04; if (d) this.frame = (v.currentTime / d) * this.n; this.draw(); this.el.classList.add('is-frames'); };
  Spinner.prototype.tick = function () {
    var self = this;
    if (this.raf) return;
    var last = performance.now(), wasIdle = true;
    if (this.mode === 'auto') this.filmPlay();
    function loop(t) {
      var dt = Math.min(50, t - last); last = t;
      if (!self.visible) { self.raf = null; var v = self.film(); if (v) v.pause(); return; }
      if (self.dragging) { if (wasIdle) { self.filmPause(); wasIdle = false; } self.el.classList.add('is-dragging'); }
      else {
        self.el.classList.remove('is-dragging');
        if (Math.abs(self.vel) > 0.02) { self.frame += self.vel; self.vel *= 0.94; self.draw(); wasIdle = false; }
        else if (self.mode === 'auto' && !RM) { self.idleT += dt; if (!wasIdle && self.idleT > 1200) { self.filmPlay(); wasIdle = true; } }
        else if (self.mode === 'auto' && RM) { /* reduced motion: stay on the frame */ }
      }
      self.raf = requestAnimationFrame(loop);
    }
    this.raf = requestAnimationFrame(loop);
  };
  window.PS360 = { rotateTo: function (el, i) { if (el && el.__ps360) { el.__ps360.frame = i; el.__ps360.draw(); } } };

  /* ---------------------------------------------------------------- hover-to-play tiles */
  function hoverTile(el) {
    if (el.__psHover) return; el.__psHover = true;
    var v = el.querySelector('video'); if (!v) return;
    function arm() { if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src')); }
    function play() { arm(); var p = v.play(); if (p && p.catch) p.catch(function () {}); el.classList.add('is-playing'); }
    function stop() { v.pause(); try { v.currentTime = 0; } catch (_) {} el.classList.remove('is-playing'); }
    el.addEventListener('pointerenter', play); el.addEventListener('pointerleave', stop);
    if (TOUCH && !RM && io) new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting && e.intersectionRatio >= 0.6 ? play() : stop(); }); }, { threshold: [0, 0.6] }).observe(el);
  }

  /* ---------------------------------------------------------------- chapter films */
  function film(el) {
    if (el.__psFilm) return; el.__psFilm = true;
    var v = el.querySelector('video'); if (!v) return;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var src = mobile ? (v.getAttribute('data-mobile-src') || v.getAttribute('data-desktop-src')) : (v.getAttribute('data-desktop-src') || v.getAttribute('data-mobile-src'));
    function arm() { if (src && !v.getAttribute('src')) { v.setAttribute('src', src); v.load(); } }
    function play() { if (RM) return; arm(); var p = v.play(); if (p && p.catch) p.catch(function () {}); el.classList.add('is-playing'); }
    function pause() { v.pause(); el.classList.remove('is-playing'); }
    v.addEventListener('playing', function () { el.classList.add('is-playing'); });
    if (!io) { play(); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) arm(); }); }, { rootMargin: '100% 0px' }).observe(el);
    new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting && e.intersectionRatio >= 0.5 ? play() : pause(); }); }, { threshold: [0, 0.5] }).observe(el);
  }

  /* ---------------------------------------------------------------- snap carousel */
  function carousel(el) {
    if (el.__psCar) return; el.__psCar = true;
    var track = el.querySelector('.ps-carousel__track'); if (!track) return;
    var items = Array.prototype.slice.call(track.children), dots = el.querySelector('[data-ps-carousel-dots]');
    var prev = el.querySelector('[data-ps-carousel-prev]'), next = el.querySelector('[data-ps-carousel-next]');
    function step() { return items[0] ? items[0].getBoundingClientRect().width + 18 : track.clientWidth * 0.8; }
    function go(d) { track.scrollBy({ left: d * step(), behavior: RM ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); }); if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(1); e.preventDefault(); } if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); } });
    var btns = [];
    if (dots) { items.forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to card ' + (i + 1)); b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: RM ? 'auto' : 'smooth' }); }); dots.appendChild(b); btns.push(b); }); }
    var t = null;
    function update() { var i = Math.round(track.scrollLeft / step()); btns.forEach(function (b, k) { b.classList.toggle('is-active', k === Math.max(0, Math.min(items.length - 1, i))); }); }
    track.addEventListener('scroll', function () { if (t) return; t = setTimeout(function () { t = null; update(); }, 80); }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------- reveal / stagger */
  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-ps-reveal]:not(.is-in)');
    if (!io || RM) { Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); }); }
    else {
      /* Tall sections (e.g. the 20,000-px documents wall) can never reach a 15 % intersection ratio, so they never revealed. Reveal on any intersection, and reveal very tall blocks immediately. */
      var ob = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in', 'is-visible', 'ps-revealed', 'psfx-in'); ob.unobserve(e.target); } }); }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
      Array.prototype.forEach.call(els, function (e) { if (e.getBoundingClientRect().height > window.innerHeight * 0.6) { e.classList.add('is-in', 'is-visible', 'ps-revealed', 'psfx-in'); } else { ob.observe(e); } });
    }
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ps-stagger]'), function (g) {
      if (g.__psStag) return; g.__psStag = true;
      var kids = Array.prototype.slice.call(g.children);
      function fire() { kids.forEach(function (k, i) { setTimeout(function () { k.classList.add('is-in'); }, RM ? 0 : i * 60); }); }
      if (!io || RM) fire(); else { var ob2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { fire(); ob2.disconnect(); } }); }, { threshold: 0.15 }); ob2.observe(g); }
    });
  }

  /* ---------------------------------------------------------------- 8,000 PPB live fill (autoplay, no controls)
     One 10-s electrolysis film = one 10-min high-mode cycle. Every real second = one minute on the digital clock and
     +800 PPB on the counter (stepped, rolling digits). At 8,000 the whole screen bursts into hydrogen micro-bubbles, then the cycle restarts. */
  var FILL_PPB = 8000, FILL_MIN = 10, FILL_STEP = 800, FILL_MARK_MIN = 5, FILL_SECS = 600;
  function Fill(mount) {
    if (mount.__psFill) return; mount.__psFill = this;
    var self = this, mobile = window.innerWidth < 750;
    this.src = (mobile && mount.getAttribute('data-ps-video-mobile')) || mount.getAttribute('data-ps-video') || '';
    this.poster = mount.getAttribute('data-ps-poster') || '';
    this.minute = -1; this.shown = 0; this.rollFrom = 0; this.rollTo = 0; this.rollAt = 0; this.done = false; this.inView = false; this.bursting = false; this.dur = 10;
    var label = 'The H88 bottle filling with hydrogen-rich water as the concentration counter rises to 8,000+ PPB';
    var root = document.createElement('div'); root.className = 'ps-anim ps-fill';
    root.innerHTML =
      '<div class="ps-anim__stage ps-fill__stage">' +
        (RM ? '<img class="ps-anim__video ps-fill__video" src="' + this.poster + '" alt="" role="img" aria-label="' + label + '">'
            : '<video class="ps-anim__video ps-fill__video" muted playsinline preload="auto" poster="' + this.poster + '" src="' + this.src + '" role="img" aria-label="' + label + '"></video>') +
        '<div class="ps-fill__glow" aria-hidden="true"></div>' +
      '</div>' +
      '<div class="ps-anim__data">' +
        '<p class="ps-anim__eyebrow">High mode · live fill</p>' +
        '<p class="ps-anim__count" aria-live="off"><span class="ps-anim__count-num">0</span><span class="ps-anim__count-unit">PPB</span></p>' +
        '<p class="ps-anim__timer"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none"><circle cx="12" cy="13" r="8" stroke="currentColor" stroke-width="1.6"/><path d="M12 9v4l2.6 1.8M9.5 2.5h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg><span class="ps-anim__timer-num">00:00</span><span class="ps-anim__timer-cap">/ 10:00 high mode</span></p>' +
        '<p class="ps-anim__marker"><span class="ps-anim__marker-dot" aria-hidden="true"></span>Standard mode · 5 min <strong>4,000+ PPB</strong></p>' +
        '<p class="ps-anim__badge" aria-hidden="true"><span class="ps-anim__badge-chip"><svg class="ps-anim__badge-line" viewBox="0 0 64 20" width="46" height="15" aria-hidden="true" fill="none"><path d="M1 11h14l4-7 6 13 5-16 5 10h28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>PEAK</span></span></p>' +
      '</div>';
    var foot = document.createElement('p'); foot.className = 'ps-anim__footnote';
    foot.textContent = 'High mode rated 8,000+ PPB. Lab-measured: 8,600 PPB (QTT, report LH2025110014-1, end of 10-min cycle in the sealed cup; drink it fresh, concentration declines after opening).';
    mount.appendChild(root); mount.appendChild(foot);
    this.root = root; this.stage = root.querySelector('.ps-fill__stage'); this.video = root.querySelector('video'); this.glow = root.querySelector('.ps-fill__glow');
    this.count = root.querySelector('.ps-anim__count'); this.countNum = root.querySelector('.ps-anim__count-num'); this.timer = root.querySelector('.ps-anim__timer');
    this.timerNum = root.querySelector('.ps-anim__timer-num'); this.marker = root.querySelector('.ps-anim__marker'); this.badge = root.querySelector('.ps-anim__badge');
    if (RM || !this.video) { this.setMinute(FILL_MIN, true); this.finish(true); return; }
    this.video.addEventListener('loadedmetadata', function () { self.dur = self.video.duration || 10; });
    this.video.addEventListener('ended', function () { if (!self.done) { self.setMinute(FILL_MIN, true); self.finish(); } });
    if (io) {
      var ob = new IntersectionObserver(function (es) { es.forEach(function (e) { self.inView = e.isIntersecting && e.intersectionRatio >= 0.3; if (self.inView) self.play(); else self.hold(); }); }, { threshold: [0, 0.3] });
      ob.observe(root);
    } else { this.inView = true; this.play(); }
    this.tick = this.tick.bind(this); requestAnimationFrame(this.tick);
  }
  Fill.prototype.play = function () { if (this.done || this.bursting || !this.inView) return; var pr = this.video.play(); if (pr && pr.catch) pr.catch(function () {}); };
  Fill.prototype.hold = function () { if (this.video && !this.video.paused) this.video.pause(); };
  Fill.prototype.tick = function (now) {
    if (!this.done && !this.bursting) {
      var d = this.dur || 10, t = Math.min(d, this.video.currentTime || 0), p = t / d;
      var ppb = Math.min(FILL_PPB, Math.round(FILL_PPB * p)), secs = Math.min(FILL_SECS, FILL_SECS * p);
      if (ppb !== this.shown) { this.shown = ppb; this.countNum.textContent = ppb.toLocaleString('en-US'); }
      var mm = Math.floor(secs / 60), ss = Math.floor(secs % 60), ts = pad(mm) + ':' + pad(ss);
      if (ts !== this.lastTs) { this.lastTs = ts; this.timerNum.textContent = ts; }
      this.glow.style.opacity = (0.1 + 0.9 * p).toFixed(3);
      this.marker.classList.toggle('is-hit', p >= FILL_MARK_MIN / FILL_MIN);
      if (p >= 0.999 || this.video.ended) this.finish();
    }
    requestAnimationFrame(this.tick);
  };
  Fill.prototype.setMinute = function (m) {
    this.shown = Math.min(FILL_PPB, m * FILL_STEP); this.countNum.textContent = this.shown.toLocaleString('en-US');
    this.timerNum.textContent = pad(m) + ':00'; this.marker.classList.toggle('is-hit', m >= FILL_MARK_MIN);
  };
  Fill.prototype.finish = function (still) {
    if (this.done) return; this.done = true; this.video && this.video.pause();
    this.shown = FILL_PPB; this.countNum.textContent = '8,000+'; this.timerNum.textContent = '10:00';
    this.count.classList.add('is-peak'); this.badge.classList.add('is-on'); this.root.classList.add('is-done');
    if (still || RM) return;
    var self = this, r = this.stage.getBoundingClientRect();
    this.bursting = true;
    Burst.get().start(r.left + r.width / 2, r.top + r.height * 0.5, function () {
      self.bursting = false;
      setTimeout(function () { self.restart(); }, 1400);
    });
  };
  Fill.prototype.restart = function () {
    this.done = false; this.minute = -1; this.shown = 0; this.rollAt = 0; this.lastTs = '';
    this.countNum.textContent = '0'; this.timerNum.textContent = '00:00';
    this.count.classList.remove('is-peak'); this.badge.classList.remove('is-on'); this.marker.classList.remove('is-hit'); this.root.classList.remove('is-done');
    try { this.video.currentTime = 0; } catch (e) { /* noop */ }
    this.play();
  };

  /* Full-screen hydrogen burst: thousands of micro-bubbles flood the viewport from the bottle, hold with the 8,000 PPB mark, then rise away. */
  var Burst = {
    inst: null,
    get: function () { return this.inst || (this.inst = new BurstFx()); }
  };
  function BurstFx() {
    var el = document.createElement('div'); el.className = 'ps-burst'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<canvas class="ps-burst__canvas"></canvas><div class="ps-burst__label"><span class="ps-burst__num">8,000<i>+</i></span><span class="ps-burst__unit">PPB</span><span class="ps-burst__cap"><svg viewBox="0 0 64 20" width="46" height="15" fill="none"><path d="M1 11h14l4-7 6 13 5-16 5 10h28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>PEAK</span></div>';
    document.body.appendChild(el);
    this.el = el; this.cv = el.querySelector('canvas'); this.ctx = this.cv.getContext('2d'); this.label = el.querySelector('.ps-burst__label');
    this.sprites = {}; this.parts = []; this.running = false;
  }
  BurstFx.prototype.sprite = function (r) {
    var key = Math.round(r * 2); if (this.sprites[key]) return this.sprites[key];
    var d = Math.ceil(r * 2 + 2), c = document.createElement('canvas'); c.width = c.height = d; var x = c.getContext('2d'), cx = d / 2;
    var g = x.createRadialGradient(cx, cx, 0, cx, cx, r);
    g.addColorStop(0, 'rgba(180,225,255,0.10)'); g.addColorStop(0.62, 'rgba(190,230,255,0.22)'); g.addColorStop(0.86, 'rgba(255,255,255,0.85)'); g.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = g; x.beginPath(); x.arc(cx, cx, r, 0, Math.PI * 2); x.fill();
    if (r >= 3) { x.fillStyle = 'rgba(255,255,255,0.9)'; x.beginPath(); x.arc(cx - r * 0.35, cx - r * 0.38, Math.max(0.6, r * 0.18), 0, Math.PI * 2); x.fill(); }
    return (this.sprites[key] = c);
  };
  BurstFx.prototype.start = function (ox, oy, done) {
    var W = window.innerWidth, H = window.innerHeight, dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.cv.width = Math.round(W * dpr); this.cv.height = Math.round(H * dpr); this.cv.style.width = W + 'px'; this.cv.style.height = H + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var N = Math.max(1600, Math.min(7000, Math.round(W * H / 190))), parts = new Array(N);
    for (var i = 0; i < N; i++) {
      var u = Math.random(), r = u < 0.58 ? 0.9 + Math.random() * 1.3 : u < 0.85 ? 2.2 + Math.random() * 1.8 : u < 0.96 ? 4 + Math.random() * 3 : 7 + Math.random() * 6;
      var ang = Math.random() * Math.PI * 2, sp = 260 + Math.random() * 1500, src = Math.random();
      parts[i] = {
        x: src < 0.7 ? ox + (Math.random() - 0.5) * 60 : Math.random() * W, y: src < 0.7 ? oy + (Math.random() - 0.5) * 220 : H + 20 + Math.random() * 120,
        vx: src < 0.7 ? Math.cos(ang) * sp : (Math.random() - 0.5) * 60, vy: src < 0.7 ? Math.sin(ang) * sp - 240 : -(300 + Math.random() * 700),
        r: r, a: 0.55 + Math.random() * 0.45, delay: Math.random() * 0.75, wob: Math.random() * Math.PI * 2, ws: 2 + Math.random() * 4, wa: 8 + Math.random() * 26
      };
    }
    this.parts = parts; this.W = W; this.H = H; this.t0 = 0; this.last = 0; this.done = done; this.running = true;
    this.el.classList.add('is-on'); this.label.classList.remove('is-in');
    var self = this; requestAnimationFrame(function (ts) { self.t0 = ts; self.last = ts; self.frame(ts); });
  };
  BurstFx.prototype.frame = function (ts) {
    if (!this.running) return;
    var T = (ts - this.t0) / 1000, dt = Math.min(0.05, (ts - this.last) / 1000); this.last = ts;
    var ctx = this.ctx, W = this.W, H = this.H, END = 5.2;
    var tint = T < 0.9 ? 0.82 * (T / 0.9) : T < 3.6 ? 0.82 : Math.max(0, 0.82 * (1 - (T - 3.6) / 1.4));
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = 'rgba(6,28,44,' + tint.toFixed(3) + ')'; ctx.fillRect(0, 0, W, H);
    if (T > 0.55 && T < 3.8) this.label.classList.add('is-in'); else this.label.classList.remove('is-in');
    var fade = T < 3.5 ? 1 : Math.max(0, 1 - (T - 3.5) / 1.5), rise = T < 3.3 ? 0 : (T - 3.3) * 900;
    var ps = this.parts;
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i]; if (T < p.delay) continue;
      var drag = Math.pow(0.12, dt);
      p.vx *= drag; p.vy = p.vy * drag - 55 * dt - rise * dt * 0.9;
      p.x += (p.vx + Math.sin(p.wob + T * p.ws) * p.wa) * dt; p.y += p.vy * dt;
      if (p.y < -20 || p.x < -20 || p.x > W + 20) { if (T < 3.3) { p.y = H + 10; p.x = Math.random() * W; p.vy = -(120 + Math.random() * 260); p.vx = 0; } else continue; }
      var life = Math.min(1, (T - p.delay) / 0.35);
      ctx.globalAlpha = p.a * life * fade * (T < 3.3 ? 1 : 1);
      var s = this.sprite(p.r), d = s.width;
      ctx.drawImage(s, p.x - d / 2, p.y - d / 2, d, d);
    }
    ctx.globalAlpha = 1;
    if (T >= END) { this.running = false; this.el.classList.remove('is-on'); this.label.classList.remove('is-in'); ctx.clearRect(0, 0, W, H); var cb = this.done; this.done = null; if (cb) cb(); return; }
    var self = this; requestAnimationFrame(function (t) { self.frame(t); });
  };

  /* ---------------------------------------------------------------- thumbnails: hover previews on the main stage (no click needed) */
  function thumbPeek(strip) {
    if (strip.__psPeek) return; strip.__psPeek = true;
    var scope = strip.parentElement, stage = scope && scope.querySelector('.ps-360'); if (!stage) return;
    var peek = document.createElement('img'); peek.className = 'ps-360__peek'; peek.alt = ''; peek.decoding = 'async'; stage.appendChild(peek);
    var timer = 0;
    Array.prototype.forEach.call(strip.querySelectorAll('a'), function (a) {
      var img = a.querySelector('img'); if (!img) return;
      var full = a.getAttribute('href') && /\.(webp|jpe?g|png)(\?|$)/i.test(a.getAttribute('href')) ? a.getAttribute('href') : (img.currentSrc || img.src);
      function show() { clearTimeout(timer); peek.src = full; stage.classList.add('is-peeking'); }
      function hide() { timer = setTimeout(function () { stage.classList.remove('is-peeking'); }, 120); }
      a.addEventListener('mouseenter', show); a.addEventListener('focus', show);
      a.addEventListener('mouseleave', hide); a.addEventListener('blur', hide);
      if (TOUCH) a.addEventListener('click', function (e) { if (!stage.classList.contains('is-peeking') || peek.src !== full) { e.preventDefault(); show(); } }, { passive: false });
    });
    stage.addEventListener('mouseenter', function () { stage.classList.remove('is-peeking'); });
  }

  /* ---------------------------------------------------------------- recently viewed (localStorage, product .js endpoint, no tracking) */
  function recentlyViewed(sec) {
    if (sec.__psRecent) return; sec.__psRecent = true;
    var KEY = 'psRecentProducts', cur = sec.getAttribute('data-ps-recent-current') || (document.body.classList.contains('is-product') && (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1]) || '';
    var list = []; try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (cur) { list = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 6); try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* noop */ } }
    var show = list.filter(function (h) { return h !== cur; }).slice(0, 3);
    if (!show.length) return;
    var grid = sec.querySelector('[data-ps-recent-grid]'); if (!grid) return;
    var done = 0;
    show.forEach(function (h) {
      fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (pjs) {
        if (!pjs) return;
        var img = (pjs.featured_image || (pjs.images && pjs.images[0]) || ''); if (img && img.indexOf('//') === 0) img = 'https:' + img;
        /* plain CDN URL (Shopify files/ paths) */
        var price = (pjs.price / 100).toLocaleString('en-US', { minimumFractionDigits: 0 });
        var a = document.createElement('a'); a.className = 'ps-recent__card'; a.href = '/products/' + pjs.handle;
        a.innerHTML = '<span class="ps-recent__img"><img src="' + img + '" alt="" decoding="async"></span><span class="ps-recent__title">' + pjs.title + '</span><span class="ps-recent__price">AED ' + price + '</span>';
        grid.appendChild(a); done++; sec.hidden = false; sec.classList.add('is-in');
      }).catch(function () {});
    });
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-360]'), function (e) { new Spinner(e); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-hover-video]'), hoverTile);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-film]'), film);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-carousel]'), carousel);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-fill]'), function (e) { new Fill(e); });
    Array.prototype.forEach.call(root.querySelectorAll('.ps-thumbs'), thumbPeek);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ps-recent]'), recentlyViewed);
    reveal(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
